import {X500PrincipalRequest} from "components/src/api/admin/generated";
import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {Dispatch, SetStateAction} from "react";
import Card from 'react-bootstrap/Card';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';

export interface X500SubjectProps {
    header: string
    subject : X500PrincipalRequest
    setSubject : Dispatch<SetStateAction<X500PrincipalRequest>>
    keyLength : number
    setKeyLength : Dispatch<SetStateAction<number>>
    validity : number
    setValidity : Dispatch<SetStateAction<number>>
}

export const X500Subject = ({header, subject, setSubject, keyLength, setKeyLength, validity, setValidity} : X500SubjectProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    function updateSubject(key: string, value: string) {
        setSubject({...subject, [key] : value})
    }

    return (
        <Card>
            <Card.Header className="text-bg-secondary">{header}</Card.Header>
            <Card.Body>
                <FloatingLabel label={t("x500-subject.common-name")} className="text-secondary mb-3">
                    <Form.Control type="text" placeholder={t("x500-subject.common-name")} value={subject.commonName}
                                  onChange={e => updateSubject("commonName", e.target.value)}/>
                </FloatingLabel>

                <FloatingLabel label={t("x500-subject.email-address")} className="text-secondary mb-3">
                    <Form.Control type="email" placeholder={t("x500-subject.email-address")} value={subject.email}
                                  onChange={e => updateSubject("email", e.target.value)}/>
                </FloatingLabel>

                <FloatingLabel label={t("x500-subject.organization")} className="text-secondary mb-3">
                    <Form.Control type="text" placeholder="Organisation" value={subject.organisation}
                                  onChange={e => updateSubject("organisation", e.target.value)}/>
                </FloatingLabel>

                <FloatingLabel label={t("x500-subject.organizational-unit")}  className="text-secondary mb-3">
                    <Form.Control type="text" placeholder={t("x500-subject.organizational-unit")} value={subject.organisationalUnit}
                                  onChange={e => updateSubject("organisationalUnit", e.target.value)}/>
                </FloatingLabel>

                <FloatingLabel label={t("x500-subject.country-code")}  className="text-secondary mb-3">
                    <Form.Control type="text" placeholder={t("x500-subject.country-code")} value={subject.countryCode}
                                  onChange={e => updateSubject("countryCode", e.target.value)}/>
                </FloatingLabel>

                <FloatingLabel label={t("x500-subject.state")}  className="text-secondary mb-3">
                    <Form.Control type="text" placeholder={t("x500-subject.state")} value={subject.state}
                                  onChange={e => updateSubject("state", e.target.value)}/>
                </FloatingLabel>

                <FloatingLabel label={t("x500-subject.locality")}  className="text-secondary mb-3">
                    <Form.Control type="text" placeholder={t("x500-subject.locality")} value={subject.locality}
                                  onChange={e => updateSubject("locality", e.target.value)}/>
                </FloatingLabel>

                <FloatingLabel label={t("x500-subject.given-name")}  className="text-secondary mb-3">
                    <Form.Control type="text" placeholder={t("x500-subject.given-name")} value={subject.givenName}
                                  onChange={e => updateSubject("givenName", e.target.value)}/>
                </FloatingLabel>

                <FloatingLabel label={t("x500-subject.surname")}  className="text-secondary mb-3">
                    <Form.Control type="text" placeholder={t("x500-subject.surname")}  value={subject.surname}
                                  onChange={e => updateSubject("surname", e.target.value)}/>
                </FloatingLabel>

                <Form.Group className="mb-3">
                    <Form.Label>{t("x500-subject.key-length")}</Form.Label>
                    <Form.Select size="sm"
                                 aria-label={t("x500-subject.key-length")}
                                 value={keyLength}
                                 onChange={(e) => setKeyLength(Number(e.target.value))}>
                        <option value="2048">2048</option>
                        <option value="3072">3072</option>
                        <option value="4096">4096</option>
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Validity (in days)</Form.Label>
                    <Form.Control className="w-auto"
                                  type="number"
                                  size="sm"
                                  min={1}
                                  max={10950}
                                  value={validity}
                                  onChange={e => setValidity(Number(e.target.value))}
                                  title={t("x500-subject.validity-in-days")}
                    />
                </Form.Group>
            </Card.Body>
        </Card>
    )
}
